var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8387 68.5484H57.5806V79.5161H54.8387V68.5484Z",
    fill: "#25A18E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3226 68.5484H63.0645V79.5161H60.3226V68.5484Z",
    fill: "#25A18E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0323 47.9702V19.1935H71.2903V5.23573L68.5484 5.69226V2.74194H65.8064V6.15016L63.0645 6.60669V0H60.3226V7.0646L57.5806 7.52113V2.74194H54.8387V7.97766L52.0968 8.43419V19.1935H49.3548V32.9032H38.3871V13.7097H32.9032V5.48387H30.1613V0H16.4516V5.48387H13.7097V13.7097H8.22581V39.3262C5.38516 40.6821 3.31637 43.387 2.85161 46.6129H0V85H85V46.4031L74.0323 47.9702ZM54.8387 10.758L68.5484 8.47258V19.1935H54.8387V10.758ZM52.0968 21.9355H71.2903V48.3623L63.0645 49.5372V56.6676L58.9516 51.1837L54.8387 56.6676V32.9032H52.0968V21.9355ZM52.0968 38.3871H32.9032V35.6452H52.0968V38.3871ZM52.0968 65.8064H65.8064V82.2581H52.0968V65.8064ZM53.4677 63.0645L58.9516 55.7531L64.4355 63.0645H53.4677ZM19.1935 2.74194H27.4194V5.48387H19.1935V2.74194ZM16.4516 8.22581H30.1613V13.7097H16.4516V8.22581ZM10.9677 16.4516H35.6452V32.9032H30.1613V39.3262C28.9123 38.7312 27.5208 38.3871 26.0484 38.3871H12.3387C11.8726 38.3871 11.4174 38.4323 10.9677 38.4968V16.4516ZM12.3387 41.129H26.0484C29.3579 41.129 32.1273 43.4885 32.7648 46.6129H5.62234C6.25984 43.4885 9.02919 41.129 12.3387 41.129ZM35.6452 49.3548V52.0968H2.74194V49.3548H35.6452ZM30.1613 74.0323H24.6774V68.5484H30.1613V74.0323ZM21.9355 74.0323H16.4516V68.5484H21.9355V74.0323ZM21.9355 76.7742V82.2581H16.4516V76.7742H21.9355ZM24.6774 76.7742H30.1613V82.2581H24.6774V76.7742ZM30.1613 65.8064H24.6774V60.3226H30.1613V65.8064ZM21.9355 65.8064H16.4516V60.3226H21.9355V65.8064ZM13.7097 65.8064H8.22581V60.3226H13.7097V65.8064ZM8.22581 68.5484H13.7097V74.0323H8.22581V68.5484ZM8.22581 76.7742H13.7097V82.2581H8.22581V76.7742ZM32.9032 82.2581V57.5806H5.48387V82.2581H2.74194V54.8387H35.6452V82.2581H32.9032ZM35.5355 46.6129C35.2394 44.5537 34.2934 42.7015 32.9032 41.2812V41.129H52.0968V60.3226L49.3548 63.979V82.2581H38.3871V46.6129H35.5355ZM82.2581 82.2581H68.5484V63.979L65.8064 60.3226V51.9144L82.2581 49.5646V82.2581Z",
    fill: "#25A18E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.129 43.871H43.871V46.6129H41.129V43.871Z",
    fill: "#25A18E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.129 76.7742H43.871V79.5161H41.129V76.7742Z",
    fill: "#25A18E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.129 49.3548H43.871V52.0968H41.129V49.3548Z",
    fill: "#25A18E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.129 71.2903H43.871V74.0322H41.129V71.2903Z",
    fill: "#25A18E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.129 60.3226H43.871V63.0645H41.129V60.3226Z",
    fill: "#25A18E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.129 54.8387H43.871V57.5807H41.129V54.8387Z",
    fill: "#25A18E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.129 65.8065H43.871V68.5484H41.129V65.8065Z",
    fill: "#25A18E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6129 54.8387H49.3549V57.5807H46.6129V54.8387Z",
    fill: "#25A18E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6129 49.3548H49.3549V52.0968H46.6129V49.3548Z",
    fill: "#25A18E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6129 43.871H49.3549V46.6129H46.6129V43.871Z",
    fill: "#25A18E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7742 76.7742H79.5161V79.5161H76.7742V76.7742Z",
    fill: "#25A18E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7742 65.8065H79.5161V68.5484H76.7742V65.8065Z",
    fill: "#25A18E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7742 71.2903H79.5161V74.0322H76.7742V71.2903Z",
    fill: "#25A18E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7742 60.3226H79.5161V63.0645H76.7742V60.3226Z",
    fill: "#25A18E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7742 54.8387H79.5161V57.5807H76.7742V54.8387Z",
    fill: "#25A18E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2903 71.2903H74.0323V74.0322H71.2903V71.2903Z",
    fill: "#25A18E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2903 54.8387H74.0323V57.5807H71.2903V54.8387Z",
    fill: "#25A18E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2903 65.8065H74.0323V68.5484H71.2903V65.8065Z",
    fill: "#25A18E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2903 76.7742H74.0323V79.5161H71.2903V76.7742Z",
    fill: "#25A18E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2903 60.3226H74.0323V63.0645H71.2903V60.3226Z",
    fill: "#25A18E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1613 19.1935H32.9033V21.9355H30.1613V19.1935Z",
    fill: "#25A18E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6774 19.1935H27.4194V21.9355H24.6774V19.1935Z",
    fill: "#25A18E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7097 19.1935H16.4516V21.9355H13.7097V19.1935Z",
    fill: "#25A18E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1935 19.1935H21.9355V21.9355H19.1935V19.1935Z",
    fill: "#25A18E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1935 24.6774H21.9355V27.4194H19.1935V24.6774Z",
    fill: "#25A18E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1613 24.6774H32.9033V27.4194H30.1613V24.6774Z",
    fill: "#25A18E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7097 24.6774H16.4516V27.4194H13.7097V24.6774Z",
    fill: "#25A18E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6774 24.6774H27.4194V27.4194H24.6774V24.6774Z",
    fill: "#25A18E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7097 30.1613H16.4516V32.9032H13.7097V30.1613Z",
    fill: "#25A18E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1935 30.1613H21.9355V32.9032H19.1935V30.1613Z",
    fill: "#25A18E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6774 30.1613H27.4194V32.9032H24.6774V30.1613Z",
    fill: "#25A18E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8065 24.6774H68.5484V27.4194H65.8065V24.6774Z",
    fill: "#25A18E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3226 24.6774H63.0645V27.4194H60.3226V24.6774Z",
    fill: "#25A18E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8387 24.6774H57.5806V27.4194H54.8387V24.6774Z",
    fill: "#25A18E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8065 30.1613H68.5484V32.9032H65.8065V30.1613Z",
    fill: "#25A18E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8387 30.1613H57.5806V32.9032H54.8387V30.1613Z",
    fill: "#25A18E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3226 30.1613H63.0645V32.9032H60.3226V30.1613Z",
    fill: "#25A18E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3226 46.6129H63.0645V49.3549H60.3226V46.6129Z",
    fill: "#25A18E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3226 41.129H63.0645V43.871H60.3226V41.129Z",
    fill: "#25A18E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3226 35.6452H63.0645V38.3871H60.3226V35.6452Z",
    fill: "#25A18E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8065 41.129H68.5484V43.871H65.8065V41.129Z",
    fill: "#25A18E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8065 35.6452H68.5484V38.3871H65.8065V35.6452Z",
    fill: "#25A18E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/BuildingIcon.e8a367fcbba1da83813cc64697605cf2.svg";
export { ForwardRef as ReactComponent };